import React from 'react';
import {Box, TextField, Button, Link } from '@mui/material';
import { BASEURL,PRIMARYCOLOR,SECONDARYCOLOR,logoURL,COMPANY } from '../../Constants';

function SignupForm({setEmail,handleSignup,handleModalOpen}){
	return(
		<div>
			<TextField
	            sx={{ width: '100%' }}
	            required
	            label="Email"
	            variant="standard"
	            onChange={(e) => setEmail(e.target.value)}
	          />
	         
	          <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '15px' }}>
	            <Button sx={{ backgroundColor: PRIMARYCOLOR }} variant="contained" onClick={handleSignup} >
	             Sign Up
	            </Button>

	            <Link sx={{ marginLeft: 'auto', color: PRIMARYCOLOR }} href="#" underline="none" onClick={handleModalOpen}>
	                Forgot Password
	            </Link>

	        </Box>
        </div>
	)
}

export default SignupForm